import Avatar from '../../../../../react/features/base/avatar/components/Avatar';
import Dialog from '../../../../../react/features/base/ui/components/web/Dialog';
import Input from '../../../../../react/features/base/ui/components/web/Input';
import Spinner from '../../../../../react/features/base/ui/components/web/Spinner';
import { participantMatchesSearch } from '../../../../../react/features/participants-pane/functions';
import React, {
    useEffect,
    useState
} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { ControlSharingMenuButton } from '../../../../components/wildix-remote-control';
import { STATUSES } from '../../../../components/wildix-remote-control/constants';

const useStyles = makeStyles()(() => {
    return {
        noParticipantsTitle: {

        },
        inputSearch: {
            marginBottom: 20,
            'input:focus': {
                boxShadow: 'none'
            },
            'input[disabled]': {
                opacity: '0.3'
            }
        },
        listItem: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: 'rgba(255, 255, 255, 0.15) 0px -1px 0px inset',
            padding: '10px 0'
        },
        leftColumn: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        userName: {
            marginLeft: 15
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            background: '#0576CC',
            paddingRight: 10,
            borderRadius: 6,
            transition: 'background 300ms ease-in-out',
            '&:hover': {
                background: '#1367A8'
            },
            '& > div': {
                '&:hover': {
                    background: 'transparent'
                }
            }
        }
    };
});

const ControlSharingDialogList = () => {
    const { classes: styles } = useStyles();
    const { t } = useTranslation();

    const { remote } = useSelector(state => state['features/base/participants']);
    const {
        controlledUserId,
        statusControl
    } = useSelector(state => state['wildix/features/control-sharing']);
    const [ searchString, setSearchString ] = useState('');
    const [ controlledUser, setControlledUser ] = useState({
        name: '',
        avatarURL: ''
    });

    const isStatusRequesting = statusControl === STATUSES.REQUESTING;
    const isStatusOpened = statusControl === STATUSES.OPENED;

    useEffect(() => {
        if (isStatusOpened) {
            setControlledUser(remote.get(controlledUserId));
        }
    }, [ statusControl ]);

    return (
        <Dialog
            disableAutoHideOnSubmit = { true }
            cancel = {{ hidden: true }}
            ok = {{ hidden: true }}
            size = 'large'
            titleKey ={ t('controlSharing.titleDialogListControls')}>
            <>
                {remote.size === 0
                    && <span className={styles.noParticipantsTitle}>{t('lonelyMeetingExperience.youAreAlone')}</span> }

                {remote.size > 0 && (
                    <div className={styles.inputSearch}>
                        <Input
                            clearable = { true }
                            disabled={ isStatusOpened }
                            onChange = { setSearchString }
                            placeholder = { t('participantsPane.search') }
                            value = { searchString } />
                    </div>
                )}

                {remote.size > 0 && isStatusOpened && (
                    <div className={styles.listItem} key={controlledUserId}>
                        <>
                            <div className={styles.leftColumn}>
                                <Avatar
                                    displayName = { controlledUser.name }
                                    participantId = { controlledUserId }
                                    url = { controlledUser.avatarURL }
                                    size = { 36 } />
                                <div className={styles.userName}>
                                    {controlledUser.name}
                                </div>
                            </div>
                            <div className= { styles.button }>
                                <ControlSharingMenuButton
                                    key = 'controlShare'
                                    participantID = { controlledUserId } />
                            </div>
                        </>
                    </div>
                )}

                {remote.size > 0 && Array.from(remote).map(currentObject => {
                    const [ participantID, participant ] = currentObject;
                    const { avatarURL, fakeParticipant, name } = participant;
                    const showLoader = controlledUserId === participantID && isStatusRequesting;
                    const isUserControlLedSharing = controlledUserId === participantID && isStatusOpened;

                    if (isUserControlLedSharing || fakeParticipant) {
                        return null;
                    }

                    return (
                        participantMatchesSearch(participant, searchString) && (
                            <div className={styles.listItem} key={participantID}>
                                <>
                                    <div className={styles.leftColumn}>
                                        <Avatar
                                            displayName = { name }
                                            participantId = { participantID }
                                            url = { avatarURL }
                                            size = { 36 } />
                                        <div className={styles.userName}>
                                            {name}
                                        </div>
                                    </div>
                                    <div className= { styles.button }>
                                        <ControlSharingMenuButton
                                            key = 'controlShare'
                                            participantID = { participantID } />
                                        {showLoader && <Spinner size = 'small' />}
                                    </div>
                                </>
                            </div>
                        )
                    );
                })}
            </>
        </Dialog>
    );
};

export default ControlSharingDialogList;
